import React from 'react';
import './styles.scss';

interface InfoboxProps {
    headline: string;
    children: JSX.Element;
}

export default function Infobox({ headline, children }: InfoboxProps): JSX.Element {
    return (
        <article className='infobox'>
            <h1>{headline}</h1>
            <div className='content'>{children}</div>
        </article>
    );
}
